module.exports = __webpack_public_path__ + "posture/static/img/pelvis_lean_left.f5bbc6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/pelvis_lean_left.png
// module id = 9JNv
// module chunks = 1